var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mr-3",attrs:{"data-cy":"copy","small":""},on:{"click":function($event){return _vm.copyToClipboard()}}},[_vm._v("mdi-content-copy")])
}
var staticRenderFns = []

export { render, staticRenderFns }